import BaseService from "./BaseService";
import { Card, Avatar, Button, Notification, toast } from "components/ui";
import React from "react";

// Toast titles a student can act on; the server's own title wins when it sends one.
const titleFor = (errors) => {
  if (errors.response?.data?.title) return errors.response.data.title;
  if (!errors.response) return "Can't reach the server";
  if (errors.response.status >= 500) return "Something went wrong on our side";
  return "Something went wrong";
};

const ApiService = {
  // Pass `suppressErrorToast: true` when the caller shows the error itself (e.g. an inline
  // message on a card), so the student does not see the same failure twice.
  fetchData({ suppressErrorToast = false, ...param } = {}) {
    return new Promise((resolve, reject) => {
      BaseService(param)
        .then((response) => {
          resolve(response);
        })
        .catch((errors) => {
          if (suppressErrorToast) {
            reject(errors);
            return;
          }
          if (errors.response && errors.response.data?.message) {
            toast.push(
              <Notification title={titleFor(errors)} type="danger">
                {errors.response.data.message}
              </Notification>
            );
          } else if (errors.response && errors.response.data) {
            toast.push(
              <Notification title={titleFor(errors)} type="danger">
                {errors.response.data?.error || errors.response.data}
              </Notification>
            );
          } else if (errors.message) {
            toast.push(
              <Notification title={titleFor(errors)} type="danger">
                {errors.response ? errors.message : "Check your connection and try again."}
              </Notification>
            );
          }
          reject(errors);
        });
    });
  },
};

export default ApiService;
